import React, { useEffect, useState } from 'react';
import { Container, NavLink, Row, Col, Nav, NavItem } from 'reactstrap';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import ListPanel from '../../common/containers/listPanel';
import entityComposition from '../../common/classes/entityComposition';
import SegmentedPicker from '../../common/controls/segmentedPicker';
import Picker from './picker';
const postChangeWarning = notificationActions => notificationActions.error({
  message: 'Please save your pending changes before changing language or disabled status.'
});
const Pickers = props => {
  const {
    pickerType: {
      indexQuery,
      list
    },
    notificationActions,
    pickerTypeActions: {
      serverIndex
    }
  } = props;
  const [lang, setLang] = useState('en');
  const [hasChange, setHasChange] = useState(false);
  const [showDisabled, setShowDisabled] = useState(0);
  const onLangChange = () => {
    if (hasChange) {
      postChangeWarning(notificationActions);
    } else {
      setLang(lang === 'en' ? 'es' : 'en');
    }
  };
  const onShowDisabledChange = () => {
    if (hasChange) {
      postChangeWarning(notificationActions);
    } else {
      setShowDisabled(showDisabled ? 0 : 1);
    }
  };
  useEffect(() => {
    serverIndex(indexQuery);
  }, [serverIndex, indexQuery]);
  const [selectedPicker, setSelectedPicker] = useState(null);
  const handleClick = picker => {
    setSelectedPicker(picker);
  };
  useEffect(() => {
    if (selectedPicker === null && list.length > 0) {
      setSelectedPicker(list[0]);
    }
  }, [list, selectedPicker]);
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(ListPanel, {
    title: "Pickers"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 12
    }
  }, /*#__PURE__*/React.createElement(SegmentedPicker, {
    names: ['Enabled', 'Disabled'],
    values: [0, 1],
    label: "Status",
    allowNull: false,
    onChange: onShowDisabledChange,
    value: showDisabled
  })), /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 12
    }
  }, /*#__PURE__*/React.createElement(SegmentedPicker, {
    names: ['English', 'Spanish'],
    values: ['en', 'es'],
    label: "Picker Language",
    allowNull: false,
    onChange: onLangChange,
    value: lang
  }))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Nav, {
    vertical: true,
    pills: true
  }, list.map(pickerTable => /*#__PURE__*/React.createElement(NavItem, {
    style: {
      maxWidth: '100%'
    },
    active: selectedPicker && selectedPicker.id === pickerTable.id,
    key: pickerTable.id,
    className: `t-p-nav-item-${kebabCase(pickerTable.name)}`
  }, /*#__PURE__*/React.createElement(NavLink, {
    onClick: () => handleClick(pickerTable)
  }, pickerTable.name)))))), /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, selectedPicker ? /*#__PURE__*/React.createElement(Picker, {
    showDisabled: showDisabled,
    lang: lang,
    onHasChange: setHasChange,
    hasChange: hasChange,
    pickerType: selectedPicker
  }) : null)));
};
Pickers.propTypes = {
  pickerType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  notificationActions: PropTypes.shape({}).isRequired,
  pickerTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired
};
export { Pickers as TestPickers };
export default entityComposition(Pickers, ['pickerType', 'notification']);